import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { inlineTextIconMargin, styled } from "@iventis/styles";
import React, { FunctionComponent, ReactNode } from "react";

import { SimpleTooltip } from "./tooltips";

interface HintLabelProps {
    label: ReactNode;
    hintText: string;
}

export const HintLabel: FunctionComponent<HintLabelProps> = ({ label, hintText }) => (
    <>
        {label}
        <SimpleTooltip text={hintText} placement="top">
            <StyledIcon size="1x" icon={["fas", "circle-info"]} />
        </SimpleTooltip>
    </>
);

const StyledIcon = styled(FontAwesomeIcon)`
    margin-left: ${inlineTextIconMargin};
`;

export default HintLabel;
